export const homeCopy = {
  searchPlaceholder: "Search for spare parts...",
  recommendedEyebrow: "For you",
  recommendedTitle: "Recommended for you",
  matchesVehicleEyebrow: "Matches your vehicle",
  matchesVehicleTitle: (vehicleLabel: string) => `For your ${vehicleLabel}`,
  categoriesEyebrow: "Browse",
  categories: "Categories",
  newArrivalsEyebrow: "Explore",
  newArrivals: "New arrivals",
  viewAll: "View All",
  emptyProductsTitle: "No products yet",
  emptyProductsDescription: "Check back soon for new arrivals.",
} as const;
